import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from '../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { InsuranceDTO } from '../../../api/useInsuranceQuery';
import { getIsOwnerTrust } from '../../utils/getIsOwnerTrust';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';

interface Props {
  data: InsuranceDTO;
}

export const GrossEstateCheckbox = ({ data }: Props) => {
  const formBag = useFormContext<FormFields>();

  const ownerModel = formBag.watch('OwnerModel');

  const isOwnerTrust =
    ownerModel.length === 1
      ? getIsOwnerTrust(ownerModel[0].Name, data.Options.InsuranceOwnerOptions)
      : false;

  if (isOwnerTrust) {
    return null;
  }

  return (
    <Controller
      control={formBag.control}
      name="IncludeInGrossEstate"
      render={({ field }) => (
        <Checkbox checked={!field.value} onChange={evt => field.onChange(!evt.target.checked)}>
          Exclude from Gross Estate
        </Checkbox>
      )}
    />
  );
};
